import env from '../config/env';
import { getService, postBodyService } from "./base.service";
import config from "../config/application";
import permission from '../api/permissions.service';
import dictionary from '../config/dictionary'
//url
const read = 'find_by_entity';
const add = 'add';
const update = 'update';

class TemplateAssignService {
    async getAssignation(entity, username) {
        let valid = await permission.validPermission(
            env.transaction.assignTemplate,
            username,
            env.app.systemCode, dictionary.configApp.action.list);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.templateAssign.url}${read}/${entity}`;
            return getService(url);
        } else {
            return valid;
        }
    }

    async add(assignation, username) {
        let valid = await permission.validPermission(
            env.transaction.assignTemplate,
            username,
            env.app.systemCode, dictionary.configApp.action.add);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.templateAssign.url}${add}`;

            return postBodyService(url, assignation);
        } else {
            return valid;
        }
    }

    async update (assignation, username) {
        let valid = await permission.validPermission(
            env.transaction.assignTemplate,
            username,
            env.app.systemCode, dictionary.configApp.action.edit);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.templateAssign.url}${update}`;

            return postBodyService(url, assignation);
        } else {
            return valid;
        }
    }
}

export default new TemplateAssignService();